import React, { useState, useEffect } from "react";
import DonationFormBanner from "./components/DonationFormBanner";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import DonationFormCard from "./components/DonationFormCard";
import DonationFormInput from "./components/DonationFormInput";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { showNotification } from "../../../../util/Utility";
import i18next2 from "./components/i18next2";

const SUPPORTED_LANGUAGES = ["en", "nl", "gr", "fr", "it"];

function DonationForm() {
  const [isSuccess, setIsSuccess] = useState(false);
  const {t} = useTranslation()
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get('campaignId');
  const shareId = searchParams.get('shareId')
  const platform = searchParams.get('platform')
  const language = searchParams.get('language');
  const [campaign, setCampaign] = useState(null)
  const isResetLinkSend = useSelector(
    (state) => state.ownerReducer?.isResetLinkSend
  );

  // ?language= used to be read and then dropped on the floor: it was passed to
  // children that ignore the prop, so a shared donation link could never set
  // the language. It only looked right because the default is Dutch.
  useEffect(()=>{
    const requested = language?.toLowerCase()
    if (requested && SUPPORTED_LANGUAGES.includes(requested)) {
      i18next2.changeLanguage(requested)
      localStorage.setItem('language', requested)
    }
  },[language])

  useEffect(()=>{
    // Without a campaignId this fetched /donation/undefined, which casts to an
    // invalid ObjectId, 500s, and shows the donor an error toast on arrival.
    if (!campaignId) return;

    const getCampaign=async()=>{
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}donation/${campaignId}`)
            setCampaign(res.data)
            
        } catch (error) {
            console.log(error);
            showNotification('error',t('error fetching campaign..'))
        }
    }
    getCampaign()
  },[campaignId])
  return (
    <div style={{marginBottom:'50px'}}>
      <DonationFormBanner language={language}/>
      <DonationFormCard language={language} campaign={campaign}/>
      <DonationFormInput language={language} campaign={campaign} shareId={shareId} platform={platform}/>
    </div>
  );
}

export default DonationForm;
